export enum SOURCES_TYPE {
  ONLINE = 'online',
  OFFLINE = 'offline'
}
